import { Grow, GrowProps } from '@mui/material';
import React, { forwardRef } from 'react';

export default forwardRef(
	(props: GrowProps, ref: React.Ref<GrowProps>) => (
		<Grow ref={ref} {...props} />
	),
);
